export default {
  TypeOfFixedAsset: 'TypeOfFixedAsset',
  FixedAsset: 'FixedAsset',
  InventoryCategory1: 'InventoryCategory1',
  InventoryItem: 'InventoryItem',
  InventoryItem1: 'InventoryItem1',
  AccountObject: 'AccountObject',
  AccountingObject: 'AccountingObject',
  Employee: 'Employee',
  BuPlanWithDraw: 'BuPlanWithDraw',
  SalaryScale: 'SalaryScale',
  PAOption: 'PAOption',
  Department: 'Department',
  DepartmentDetail: 'Department',
  EmployeeType: 'EmployeeType',
  PayrollItem: 'PayrollItem',
  BudgetSource: 'BudgetSource',
  BudgetChapter: 'BudgetChapter',
  BudgetProvide: 'BudgetProvide',
  BudgetKindItem: 'BudgetKindItem',
  BudgetItem: 'BudgetItem',
  BuPlanWithDrawDetail: 'BuPlanWithDrawDetail',
  BankInfo: 'BankInfo',
  Project: 'Project',
  Activity: 'Activity',
  Statistic: 'Statistic',
  BUTransfer: 'BUTransfer',
  BUTransferDetail: 'BUTransferDetail',
  BUTransferDetailParallel: 'BUTransferDetailParallel',
  PAEmployeeSalaryDetail: 'PAEmployeeSalaryDetail',
  Account: 'Account',
  AccountCategory: 'AccountCategory',
  BranchType: 'BranchType',
  Currency: 'Currency',
  BAWithdraw: 'BAWithdraw',
  BAWithdrawDetail: 'BAWithdrawDetail',
  BAWithdrawDetailParallel: 'BAWithdrawDetailParallel',
  InventoryCategory: 'InventoryCategory',
  Stock: 'Stock',
  BUPlanReceipt: 'BUPlanReceipt',
  BUPlanReceiptDetail: 'BUPlanReceiptDetail',
  TypeOfFund: 'TypeOfFund',
  TypeOfFundBank: 'TypeOfFundBank',
  BankInfoCategory: 'BankInfoCategory',
  BudgetGroupItem: 'BudgetGroupItem',
  BudgetGroupItem1: 'BudgetGroupItem1',
  CAReceipt: 'CAReceipt',
  CAReceiptDetail: 'CAReceiptDetail',
  CAReceiptDetailParallel: 'CAReceiptDetailParallel',
  BUPlanAdjustment: 'BUPlanAdjustment',
  BUPlanAdjustmentDetail: 'BUPlanAdjustmentDetail',
  BUVoucherList: 'BUVoucherList',
  BUVoucherListDetail: 'BUVoucherListDetail',
  BUVoucherListDetailParallel: 'BUVoucherListDetailParallel',
  BADeposit: 'BADeposit',
  BADepositDetail: 'BADepositDetail',
  BADepositDetailParallel: 'BADepositDetailParallel',
  BADepositDetailTax: 'BADepositDetailTax',
  CAPayment: 'CAPayment',
  CAPaymentDetail: 'CAPaymentDetail',
  CAPaymentDetailParallel: 'CAPaymentDetailParallel',
  CAFundInventory: 'CAFundInventory',
  InInwardOutward: 'InInwardOutward',
  InInwardOutwardDetail: 'InInwardOutwardDetail',
  InTransfer: 'InTransfer',
  InTransferDetail: 'InTransferDetail',
  InAdjustment: 'InAdjustment',
  InAdjustmentDetail: 'InAdjustmentDetail',
  SuTransfer: 'SuTransfer',
  SuTransferDetail: 'SuTransferDetail',
  SuIncrementDecrement: 'SuIncrementDecrement',
  SuIncrementDecrementDetail: 'SuIncrementDecrementDetail',
  FaIncrementDecrement: 'FaIncrementDecrement',
  FaIncrementDecrementDetail: 'FaIncrementDecrementDetail',
  FaDepreciation: 'FaDepreciation',
  FaDepreciationDetail: 'FaDepreciationDetail',
  FaAdjustment: 'FaAdjustment',
  FaAdjustmentDetail: 'FaAdjustmentDetail',
  FaAdjustmentDetailParallel: 'FaAdjustmentDetailParallel',
  PaWorkPoint: 'PaWorkPoint',
  PaWorkPointDetail: 'PaWorkPointDetail',
  PaOtherInputSalary: 'PaOtherInputSalary',
  BUPlanWDAdjustment: 'BUPlanWDAdjustment',
  BUPlanWDAdjustmentDetail: 'BUPlanWDAdjustmentDetail',
  BUTransferDetailPurchase: 'BUTransferDetailPurchase',
  AccountTransfer: 'AccountTransfer',
  SysRefType: 'SysRefType',
  AutoBusiness: 'AutoBusiness',
  BudgetFees: 'BudgetFees',
  Task: 'Task',
  PurchasePurpose: 'PurchasePurpose',
  BABankTransfer: 'BABankTransfer',
  BABankTransferDetail: 'BABankTransferDetail',
  BABankTransferDetailParallel: 'BABankTransferDetailParallel',
  CAPaymentDetailPurchase: 'CAPaymentDetailPurchase',
  SAInvoice: 'SAInvoice',
  SAInvoiceDetail: 'SAInvoiceDetail',
  BAWithdrawDetailPurchase: 'BAWithdrawDetailPurchase',
  BUBudgetReserve: 'BUBudgetReserve',
  BUBudgetReserveDetail: 'BUBudgetReserveDetail',
  AccountingObjectInfo: 'AccountingObjectInfo',
  AccountingObjectCategory: 'AccountingObjectCategory',
  InvoiceFormNumber: 'InvoiceFormNumber',
  VoucherType: 'VoucherType',
  BUCommitmentRequest: 'BUCommitmentRequest',
  BUCommitmentRequestDetail: 'BUCommitmentRequestDetail',
  BUCommitmentAdjustment: 'BUCommitmentAdjustment',
  BUCommitmentAdjustmentDetail: 'BUCommitmentAdjustmentDetail',
  BUOpeningCommitment: 'BUOpeningCommitment',
  BUOpeningCommitmentDetail: 'BUOpeningCommitmentDetail',
  ProjectBudgetDetail: 'ProjectBudgetDetail',
  Contract: 'Contract',
  Topic: 'Topic',
  TopicEstimate: 'TopicEstimate',
  GLVoucherList: 'GLVoucherList',
  GLVoucherListDetail: 'GLVoucherListDetail',
  ProjectExpense: 'ProjectExpense',
  FundStructure: 'FundStructure',
  QltsVoucher: 'QltsVoucher',
  QltsVoucherDetail: 'QltsVoucherDetail',
  QltsVoucherDetailParallel: 'QltsVoucherDetailParallel',
  BATransfer: 'BATransfer',
  BATransferDetail: 'BATransferDetail',
  BATransferDetailParallel: 'BATransferDetailParallel',
  OpeningSupplyEntry: 'OpeningSupplyEntry',
  CRERepList: 'CRERepList',
  FRTemplateCustom: 'FRTemplateCustom',
  CRERepExportList: 'CRERepExportList',
  AccountParallelRule: 'AccountParallelRule',
  AccountParallelRuleDetail: 'AccountParallelRuleDetail',
  DefaultAccount: 'DefaultAccount',
  AutoId: 'AutoId',
  OpeningAccountEntry: 'OpeningAccountEntry',
  StateBank: 'StateBank',
  BADepositDetailSale: 'BADepositDetailSale',
  PayrollItemColumn: 'PayrollItemColumn',
  // tab hệ thống khi mở setting
  OrganizationInfo: 'OrganizationInfo',
  UserManagement: 'UserManagement',
  DataManagement: 'DataManagement',
  RoleManagement: 'RoleManagement',
  BackupRestore: 'BackupRestore',
  StorageForm: 'BackupRestore',
  // tab tiện ích
  CloseBook: 'CloseBook',
  PostBatch: 'PostBatch',
  SortRefNo: 'SortRefNo',
  UtilityExportData: 'UtilityExportData', //Xuất khẩu dữ liệu
  CopyDataOther: 'CopyDataOther', // Sao chép dữ liệu

  // tab cài đặt chung

  DataMaintaince: 'DataMaintaince',

  // phân hệ hóa đơn
  SASaleInvoice: 'SASaleInvoice',
  Receipt: 'Receipt',
  // RegisterChangeInfo: 'RegisterChangeInfo',
  // CreateTemplate: 'CreateTemplate',
  // CancelInvoice: 'CancelInvoice',

  // Phân hệ kho
  Inventory: 'Inventory', // Phân hệ kho
  InventoryInInward: 'InventoryInInward', // Nhập kho
  InventoryInOutward: 'InventoryInOutward', // Xuất kho
  InTransfer: 'InTransfer', // Chuyển kho
  InventoryInAjustment: 'InventoryInAjustment', // Điều chỉnh tồn kho
  InventoryInCalculate: 'InventoryInCalculate', // Tính giá xuất kho

  // Phân hệ công cụ dụng cụ
  InventoryItemSuincrement: 'InventoryItemSuincrement', // Ghi tăng CCDC
  InventoryItemSudecrement: 'InventoryItemSudecrement', // Ghi giảm CCDC
  InventoryItemSutransfer: 'InventoryItemSutransfer', // Điều chuyển CCDC

  // Phân hệ lương
  StatisticalDayOff: 'StatisticalDayOff', // Bảng tổng hợp ngày nghỉ, làm thêm, làm đêm
  OtherIncome: 'OtherIncome', // Thu nhập không thường xuyên
  PAOtherOutcome: 'PAOtherOutcome', // Khấu trừ không thường xuyên
  PARetroSalary: 'PARetroSalary', // Truy lĩnh lương
  Salary: 'Salary', //Bảng lương
  GLPayrollExpenseSalaryList: 'GLPayrollExpenseSalaryList', // Hạch toán chi phí lương
  PaySalary: 'PaySalary', // Trả lương
  PayUnionInsurance: 'PayUnionInsurance', // Nộp bảo hiểm, công đoàn phí
  CAPaymentPersonalIncomeTax: 'CAPaymentPersonalIncomeTax', // Tính thuế TNCN
  PAPayTax: 'PAPayTax', // Nộp thuế TNCN
  SalaryFromSalagov: 'SalaryFromSalagov', //Lấy bảng lương từ salagov

  // phân hệ mua hàng
  PUPayment: 'PUPayment', // mua hàng trả tiền ngay
  PuInvoice: 'PuInvoice', // mua hàng chưa thanh toán
  PuInvoiceDetailPurchase: 'PuInvoiceDetailPurchase', // mua hàng chưa thanh toán - chi tiết
  PUVendorPayment: 'PUVendorPayment', // trả tiền nhà cung cấp
  InvoiceBot: 'InvoiceBot', // xử lý hóa đơn đầu vào

  // phân hệ bán hàng
  CAReceiptSale: 'CAReceiptSale', // bán hàng thu tiền ngay
  CAReceiptCustom: 'CAReceiptCustom', // thu tiền khách hàng
  SAInvoice: 'SAInvoice',
  SAInvoiceDetail: 'SAInvoiceDetail',
  SAReturn: 'SAReturn',
  SAReturnDetail: 'SAReturnDetail',

  // TSCĐ
  FAPurchaseIncrement: 'FAPurchaseIncrement', // Ghi tăng tSCĐ
  FATransfer: 'FATransfer', // Điều chuyển tài sản cố định
  FADepreciation: 'FADepreciation', // hao mòn
  FADevaluation: 'FADevaluation', // Trích khấu hao
  FAIncrement: 'FAIncrement', // Nhận bằng hiện vật và ghi tăng TSCĐ
  FaAdjustment: 'FaAdjustment', //Đánh giá lại TSCĐ
  FADecrement: 'FADecrement', //Ghi giảm TSCĐ
  FARevenue: 'FARevenue', //Doanh thu từ bán TSCĐ
  CAReceiptFixedAsset: 'CAReceiptFixedAsset', //Phiếu thu bán TSCĐ
  BADepositFixedAsset: 'BADepositFixedAsset', //Thu tiền gửi từ bán TSCĐ
  FASaleInvoice: 'FASaleInvoice', //Bán TSCĐ chưa thu tiền

  // phân hệ tổng hợp
  GLVoucher: 'GLVoucher', // chứng từ nghiệp vụ khác
  GLVoucherDetail: 'GLVoucherDetail',
  GLVoucherDetailTax: 'GLVoucherDetailTax',
  GLVoucherDetailParallel: 'GLVoucherDetailParallel',
  BeginningYearTransfer: 'BeginningYearTransfer', // quyết toán số dư đầu năm
  GLProfitLossTransfer: 'GLProfitLossTransfer', // Xác định kết quả hoạt dộng
  EndYearTransfer: 'EndYearTransfer', // Kết chuyển số dư cuối năm
  GLPostedVoucher: 'GLPostedVoucher', // Chứng từ ghi sổ
  VoucherSummaryTable: 'VoucherSummaryTable', // Bảng TH chứng từ cùng loại
  CreReport: 'CreReport', // Lập báo cáo
  CrerepexportListTax: 'CrerepexportListTax', // Nộp báo cáo cho cơ quan thuế
  CRERepExportList: 'CRERepExportList', // nộp báo cáo kho bạc
  FrReportConfigList: 'FrReportConfigList', // thiết lập báo cáo tài chính
  BATransferWithDraw: 'BATransferWithDraw', // tiền chuyển đến
  BATransferDeposit: 'BATransferDeposit', // tiền chuyển đi
  ProvisionalTaxIncomeEnterprised: 'ProvisionalTaxIncomeEnterprised', //Tạm tính thuế TNDN
  FinalTaxInComeEnterprise: 'FinalTaxInComeEnterprise', //Quyết toán thuế TNDN

  BUPlanCancel: 'BUPlanCancel', // hủy dự toán
  CAReceiptPlanWithdraw: 'CAReceiptPlanWithdraw', // nhập quỹ tiền mặt
  FASaleInvoice: 'FASaleInvoice', //Bán TSCĐ chưa thu tiền
  PuInvoiceDetailFixedAsset: 'PuInvoiceDetailFixedAsset', // Mua TSCĐ chưa thanh toán

  DVCUser: 'DVCUser', // Kho bạc điện tử
  InitialBalance: 'InitialBalance', // Nhập số dư ban đầu

  SendAccountingDataHD: 'SendAccountingDataHD', // gửi dữ liệu kết toán sang STC Hải Dương
  ConfirmSendAccountingDataHD: 'ConfirmSendAccountingDataHD', // thông báo chưa nhập mã địa bàn
  // file detail của danh mục
  SystemAccountDetails: 'Account',
  AccountTransferDetail: 'AccountTransfer',
  AutoBusinessDetail: 'AutoBusiness',
  BudgetChapterDetail: 'BudgetChapter',
  BudgetKindItemDetail: 'BudgetKindItem',
  BudgetItemDetail: 'BudgetItem',
  BudgetSourceDetail: 'BudgetSource',
  BudgetSourcePropertyDetail: 'BudgetGroupItem',
  TargetProgramDetail: 'Project',
  ProjectDetail: 'Project',
  WorkItemDetail: 'Project',
  TypeOfFundDetail: 'TypeOfFund',
  CurrencyDetail: 'Currency',
  BankInfoCategoryDetail: 'TypeOfFundBank',
  BankInfoDetail: 'BankInfo',
  AccountingObjectCategoryDetail: 'AccountingObjectCategory',
  CustomerVendorDetail: 'AccountingObject',
  EmployeeDetail: 'Employee',
  EmployeeTypeDetail: 'EmployeeType',
  PayrollItemDetail: 'PayrollItem',
  SalaryScaleDetail: 'SalaryScale',
  InventoryDetail: 'DicInventory',
  ToolTypeDetail: 'InventoryCategory1',
  ToolDetail: 'InventoryItem',
  InventoryCategoryDetail: 'InventoryCategory',
  InventoryDetail: 'InventoryItem1',
  StockDetail: 'Stock',
  PurchasePurposeDetail: 'PurchasePurpose',
  InvoiceFormNumberDetail: 'InvoiceFormNumber',
  VoucherTypeDetail: 'VoucherType',
  BudgetFeesDetail: 'BudgetFees',
  TaskDetail: 'Task',
  TopicDetail: 'Topic',
  ActivityDetail: 'Activity',
  FundStructureDetail: 'FundStructure',
  StatisticDetail: 'Statistic',
  BudgetGroupItemDetail: 'BudgetGroupItem1',
  ContractDetail: 'Contract',
  BUAppendixList: 'BUAppendixList',
  FARevenue: 'FARevenue',
  QltsVoucher: 'QltsVoucher',
  QltsVoucherIncreament: 'QltsVoucherIncreament', // Ghi tăng TSCĐ từ MISA QLTS
  QltsVoucherDecrement: 'QltsVoucherDecrement', // Ghi giảm TSCĐ từ MISA QLTS
  QltsVoucherAdjustment: 'QltsVoucherAdjustment', // Đánh giá lại TSCĐ từ MISA QLTS
  QltsVoucherDepreciate: 'QltsVoucherDepreciate', //Trích khấu hao TSCĐ từ MISA QLTS
  QltsVoucherDepreciate: 'QltsVoucherDepreciation', //Tính hao mòn TSCĐ từ MISA QLTS

  // Phân hệ thuế
  DeductionTA: 'DeductionTA', //Nghiệp vụ thuế->Khấu trừ thuế
  SubmitTax: 'SubmitTax', //Nghiệp vụ thuế->Nộp thuế
  TACircularVATDeclaration: 'TACircularVATDeclaration', //Nghiệp vụ thuế->Tờ khai thuế
  TARiskCustomerVendor: 'TARiskCustomerVendor', // Danh sách NCC có rủi ro
  TAEnterpriseIncomeTax: 'TAEnterpriseIncomeTax', // Nghiệp vụ thuế-> Tờ khai thuế thu nhập danh nghiệp
  Option: 'Option', //Tùy chọn hệ thống
};
